import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  filterThreads,
  filterUnreadThreads,
  filterStaredThreads,
} from 'messaging/actions/thread';
import { getFilteredThreads } from 'messaging/selectors/threads';
import ThreadsFilter from 'messaging/components/ThreadsFilter';
import ThreadList from 'messaging/components/ThreadList';

const mapStateToProps = state => ({
  threads: getFilteredThreads(state),
  filter: state.messaging.threads.threadFilter,
  filterUnread: state.messaging.threads.filterUnread,
  filterStared: state.messaging.threads.filterStared,
  selectedUser: state.messaging.mailbox.selectedUser,
});
const mapDispatchToProps = dispatch => ({
  selectThread: id => dispatch(push(`mailbox?user=${id}`)),
  filterThreads: filter => dispatch(filterThreads(filter)),
  filterUnreadThreads: () => dispatch(filterUnreadThreads()),
  filterStaredThreads: () => dispatch(filterStaredThreads()),
});
class MailboxLayout extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    selectedUser: PropTypes.string,
    threads: PropTypes.array,
    selectThread: PropTypes.func.isRequired,
    filter: PropTypes.string,
    filterThreads: PropTypes.func.isRequired,
    filterUnread: PropTypes.bool,
    filterUnreadThreads: PropTypes.func.isRequired,
    filterStared: PropTypes.bool,
    filterStaredThreads: PropTypes.func.isRequired,
  };

  render() {
    const { children, threads, selectedUser } = this.props;

    if (threads) {
      return (
        <div className="chat ui tab active">
          <div className="ui grid">
            <div className="five wide column users">
              <div className="ui segments">
                <div className="ui segment">
                  <div className="header">Discussions</div>
                </div>
                <ThreadsFilter
                  filter={this.props.filter}
                  onFilterChanged={this.props.filterThreads}
                  filterUnread={this.props.filterUnread}
                  onUnreadChecked={this.props.filterUnreadThreads}
                  filterStared={this.props.filterStared}
                  onStaredChecked={this.props.filterStaredThreads}
                />
                <ThreadList
                  threads={threads}
                  selected={selectedUser}
                  onSelect={this.props.selectThread}
                />
              </div>
            </div>
            <div className="eleven wide column messages">{children}</div>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MailboxLayout);



// WEBPACK FOOTER //
// ./src/modules/messaging/layouts/MailboxLayout.js